import { useState } from "react";
import { Box, Button, Icon } from "@storyofams/react-ui";
import Image from "next/image";
import { css } from "styled-components";
import { FixedRatio } from "~components/common/FixedRatio";
import { Heading } from "~components/common/Heading";
import { NavUnderline } from "~components/common/Icons";
import { Container } from "~components/common/Layout/Container";
import { ShopifyRichText } from "~components/product";
import { Collection } from "~lib/shopify/sdk";

interface HeaderProps {
  collection: Collection;
  extraCollectionData?: {
    title: string;
    heroImage: {
      alt: string;
      src: string;
    };
  };
}

export const Header = ({ extraCollectionData, collection }: HeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Box width="100%" textAlign="center" mb={2}>
      <Container
        space={0}
        pt={[2, extraCollectionData?.heroImage ? 1 : 0]}
        pb={0}
      >
        <Box width="100%" textAlign="center" id="description">
          {!!extraCollectionData?.heroImage?.src && (
            <FixedRatio
              ratio={[[1200, 220]]}
              width="100%"
              borderRadius="md"
              overflow="hidden"
              mb={3}
            >
              <Image
                alt={extraCollectionData.heroImage.alt || collection.title}
                src={extraCollectionData.heroImage.src}
                objectFit="cover"
                layout="fill"
                width="100%"
                height="100%"
              />
            </FixedRatio>
          )}

          <Heading variant="h1" as="h1" mb={[1.5, 2]}>
            {collection.title}
          </Heading>
          <Box display={["block", "none"]}>
            <ShopifyRichText
              content={
                isOpen
                  ? collection.descriptionHtml
                  : collection.descriptionHtml.slice(0, 185)
              }
            />
            {!isOpen && collection.description && (
              <Button
                onClick={() => setIsOpen((open) => !open)}
                display="inline"
                cursor="pointer"
                css={css({
                  ".underline": {
                    position: "absolute",
                    right: "-4px",
                    height: 12,
                    bottom: 0,
                    width: "calc(100% + 8px)",
                    transition: "width 0.32s ease-in-out",
                    zIndex: -1,
                    svg: {
                      width: "100%",
                      height: "100%",
                      color: "sand",
                    },
                  },
                  "&&:hover": {
                    ".underline": {
                      width: "0",
                    },
                  },
                })}
              >
                ...lees meer
                <Icon className="underline" icon={NavUnderline} width="100%" />
              </Button>
            )}
          </Box>
          <Box display={["none", "block"]}>
            <ShopifyRichText content={collection.descriptionHtml} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
